export const SHORT_TASK_YZ = [

    {
        id: 1,
        type: '選擇題',
        text: '1.<br/>「購買航海圖的委託人可選擇諸多裝飾性元素，再由製圖師或是在製圖師工作坊裡任職的專業藝術家繪製在底圖上。這些可供選擇的裝飾元素包括手繪城市圖像、象徵城市政治掌權者的旗幟、羅盤方位圖，以及山脈、河流、船隻等圖案，還有若干地圖中出現的海怪。這類航海圖更為精緻，因而更為昂貴──滿是裝飾性元素的航海圖甚至比實用性的航海圖貴上十倍──其並非用於導航，而是供王室和貴族收藏、展示之用。」',
        question: '根據這段文字，下列關於繪有海怪圖像航海圖的敘述何者正確？',
        options: [
            { text: 'A.	裝飾元素由製圖師決定', },
            { text: 'B.	清楚標示海怪所在位置', },
            { text: 'C.	作品絕多數為船長擁有 ', },
            { text: 'D.	該圖無法於航行中使用', correct: true },
        ],
        background: '#F8FAFB'
    }, {
        id: 2,
        type: '選擇題',
        text: '2.<br/>「好的圍棋要慢慢地下，好的生活歷程要細細品味；不要著急把棋盤下滿，也不要匆忙的走人生之路。」',
        question: '上述語句內容所要表達的意思為何?',
        options: [
            { text: 'A. 人生短暫，宜好好生活，不要心急。', correct: true },
            { text: 'B. 圍棋比賽時，可以慢慢想如何下子。', },
            { text: 'C. 人生就如下棋般，須思考如何行事。', },
            { text: 'D. 下圍棋時，應考量棋子的空間分佈。', },
        ],
        background: '#F8FAFB'

    }, {
        id: 3,
        type: '選擇題',
        text: '3.<br/>小丸子在網上看到一則帖文：「打開薯片才發現，原來空氣也是需要錢的！」',
        question: '這句話想要表達的涵義最有可能是什麼？',
        options: [
            { text: 'A. 袋內注入氣體，有助於維持食物的品質，所以空氣也算成本。' },
            { text: 'B. 諷刺產品內容物太少，包裝內充飽的氣體反而讓人覺得無言。', correct: true },
            { text: 'C. 打開袋子，薯片的香氣撲鼻而來，是零食包裝設計的巧思。' },
            { text: 'D. 從購入的薯片中，找到不肖商家品質管控不良的充分證據。' },
        ],
         background: '#F8FAFB'
    }, {
        id: 4,
        type: '選擇題',
        text: '4.<br/>「近年，法國鄉村出現很多乍看之下匪夷所思的爭議，新搬來的居民受不了鄉村常見的雞啼、蟬鳴等聲音，將他們的鄰居一狀告上法院，不僅讓老住戶被告得一頭霧水，更讓許多法國民眾開始思考起法國鄉村真正的樣貌。是以近日法國參議院通過一部法案，正式認可鄉村常聽見的雞啼、蛙鳴等聲音，都是法國鄉村『感官遺產』的一部分，未來也都在法國法律的保障範圍內，希望能藉此解決多年來都市民眾和鄉村居民間的爭議。」',
        question: '這段報導內容運用了何種寫作方式？',
        options: [
            { text: 'A. 先因後果', correct: true },
            { text: 'B. 先總後分', },
            { text: 'C. 觀點對比', },
            { text: 'D. 歸納論證', }
        ],
        background: '#F8FAFB'
    },
    {
        id: 5,
        type: '選擇題',
        text: '5.<br/>晴蓉剛上課時，看見自己課本上黏 了張便條紙，內容提及她最近剛好 想去體驗的實境遊戲題材，她好想答應邀約，可是便條紙內容卻不夠清楚，讓她無法做出決定。<br/><img src="/secondary/tasks/tt1.png" alt="便條紙">',
        question: '請問便條紙中只清楚呈現出哪一個訊息？',
        options: [
            { text: 'A. 預計體驗的日期', },
            { text: 'B. 預計體驗的時間', },
            { text: 'C. 預計體驗的遊戲', correct: true },
            { text: 'D. 預計邀約的人數', },
        ],
        background: '#F8FAFB',
    },
    {
        id: 6,
        type: '選擇題',
        text: '6.<br/>「對我而言，哲學課的目標在於能達到讓學生去反思問題，甚至打破既有的想法，能開始質疑他過去所接受的觀點或訊息。」',
        question: '這句話的涵義，與下列何者最接近？',
        options: [
            { text: 'A. 哲學的目的是為了否定過去所學。', },
            { text: 'B. 學習哲學是為了不斷對話及提問。', },
            { text: 'C. 哲學的訓練是為了打破既有框架。', correct: true },
            { text: 'D. 反思問題是哲學課程的唯一途徑。', },
        ],
        
         background: '#F8FAFB'

    }, {
        id: 7,
        type: '選擇題',
        text: '7.<br/>「□□□不只引領人類找出解決技術與科技問題的革新辦法，同時也為我們展開了各種可能性，改善真實生活中的惱人困擾。□□□並不是清晰判斷力的敵人，反而是理性的夥伴，它為現實帶來嶄新的光芒與靈性願景，這些正是我們消費至上的社會所欠缺的。」',
        question: '根據文意脈絡，□□□最可能是下列哪一項基本能力？',
        options: [
            { text: 'A. 想像力', correct: true },
            { text: 'B. 記憶力' },
            { text: 'C. 感受力' },
            { text: 'D. 觀察力' },
        ],
        background: '#F8FAFB',
    }, {
        id: 8,
        type: '選擇題',
        text: '8.<br/>「那片靜謐的湖泊位在山坳處。據導遊說，是為了紀念古老的傳說，才取了如此夢幻空靈的名字。更重要的是，湖水澄澈。這年我十歲，湖面平靜得像是一面巨大的明鏡。記憶裏我從未見過湖底的淤泥，湖水不是輕撫著岸邊的鵝卵石，就是溫柔地映照著連綿的雲朵，要不就綢緞般地滑過石縫，甚美。在我眼裏，它簡直是一座宮殿。多年後，我在畫廊看到這張油畫，那時，這座湖已乾涸十年了。」 ',
        question: '依照上文內容，下列文句，何者屬於「客觀性」的敘述？',
        options: [
            { text: 'A. 湖水不是輕撫著岸邊的鵝卵石，就是溫柔地映照著連綿的雲朵。' },
            { text: 'B. 記憶裡我從未見過湖底的淤泥，湖水綢緞般地滑過石縫，甚美。' },
            { text: 'C. 那片靜謐的湖泊位在山坳處，湖面平靜得像是一面巨大的明鏡。' },
            { text: 'D. 多年後，我在畫廊看到這張油畫，那時，這座湖已乾涸十年了。', correct: true }
        ],
        
          background: '#F8FAFB'
    }
]